module.exports = __webpack_public_path__ + "static/media/breadcrumb02.e0699e2b.png";